import Symbol from "./Symbol";
import { INSPECTOR_CABLES } from "../../../constants/inspectorConstants";

class Cable extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, name, variants}) {
        super("Cable", { alias, svgSrc, label, rotable, handles, name, variants });

        this.attributes = {
            ...this.attributes,
            brand: { isVisible: false, value: null, label: "Marca" },
            insulation: { isVisible: false, value: null, label: "Aislamiento" },
            ampacidad: { isVisible: false, value: null, label: "Ampacidad" },
            length: { isVisible: false, value: null, label: "Longitud" },
            phaseGauge: { isVisible: false, value: null, label: "Calibre fases" },
            conductorsPerPhase: { isVisible: false, value: null, label: "No. de cond. por fase" },
            neutralGauge: { isVisible: false, value: null, label: "Calibre neutro" },
            conductorsPerNeutral: { isVisible: false, value: null, label: "No. de cond. por neutro" },
            groundGauge: { isVisible: false, value: null, label: "Calibre tierra" },
            conductorsPerGround: { isVisible: false, value: null, label: "No. de cond. por tierra" },
            conduitType: { isVisible: false, value: null, label: "Canalización" },
        };                
    }
    
    getInspector() {
        return INSPECTOR_CABLES;
    }
}

export default Cable;
